module.exports = __webpack_public_path__ + "prod/1.42.2/img/pre_high_img2.d6b1fba5.png";